import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { BaseUrl, IssueId } from '@atlassian/jira-shared-types/src/general.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: BaseUrl, parentId: IssueId) =>
	performGetRequest(`${baseUrl}/rest/api/2/issue/${parentId}?fields=subtasks`);
